import _bindInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/bind';
import _fillInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/fill';
import classNames from 'classnames/bind';
import React, { memo } from 'react';
import style from './LoadingBasic.module.scss.js';

var cx = _bindInstanceProperty(classNames).call(classNames, style);
var LoadingBasic = /*#__PURE__*/memo(function (_ref) {
  var _ref$fill = _fillInstanceProperty(_ref),
    fill = _ref$fill === void 0 ? 'rgb(3,199,90)' : _ref$fill,
    _ref$fill2 = _ref.fill2,
    fill2 = _ref$fill2 === void 0 ? 'rgb(2,177,145)' : _ref$fill2,
    _ref$fill3 = _ref.fill3,
    fill3 = _ref$fill3 === void 0 ? 'rgb(0,154,199)' : _ref$fill3,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? '100%' : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? '100%' : _ref$height,
    _ref$viewBox = _ref.viewBox,
    viewBox = _ref$viewBox === void 0 ? '0 0 38 10' : _ref$viewBox;
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    className: cx('loadingBasic'),
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    width: width,
    height: height,
    viewBox: viewBox
  }, /*#__PURE__*/React.createElement("g", {
    className: cx('bar2_ts'),
    transform: "translate(5,5) scale(0,0)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: cx('bar2'),
    r: "5",
    transform: "translate(0,0)",
    opacity: "0",
    fill: fill,
    stroke: "none",
    strokeWidth: "1"
  })), /*#__PURE__*/React.createElement("g", {
    className: cx('bar3_to'),
    transform: "translate(5,5)"
  }, /*#__PURE__*/React.createElement("g", {
    className: cx('bar3_ts'),
    transform: "scale(0,0)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: cx('bar3'),
    r: "5",
    transform: "translate(0,0)",
    opacity: "0",
    fill: fill2,
    stroke: "none",
    strokeWidth: "1"
  }))), /*#__PURE__*/React.createElement("g", {
    className: cx('bar4_to'),
    transform: "translate(5,5)"
  }, /*#__PURE__*/React.createElement("g", {
    className: cx('bar4_ts'),
    transform: "scale(0,0)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: cx('bar4'),
    r: "5",
    transform: "translate(0,0)",
    opacity: "0",
    fill: fill3,
    stroke: "none",
    strokeWidth: "1"
  }))), /*#__PURE__*/React.createElement("g", {
    className: cx('bar5_ts'),
    transform: "translate(33,5) scale(1,1)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: cx('bar5'),
    r: "5",
    transform: "translate(0,0)",
    fill: fill3,
    stroke: "none",
    strokeWidth: "1"
  })), /*#__PURE__*/React.createElement("g", {
    className: cx('bar6_to'),
    transform: "translate(5,5)"
  }, /*#__PURE__*/React.createElement("g", {
    className: cx('bar6_ts'),
    transform: "scale(1,1)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: cx('bar6'),
    r: "5",
    transform: "translate(0,0)",
    fill: fill,
    stroke: "none",
    strokeWidth: "1"
  }))), /*#__PURE__*/React.createElement("g", {
    className: cx('bar7_to'),
    transform: "translate(19,5)"
  }, /*#__PURE__*/React.createElement("g", {
    className: cx('bar6_ts'),
    transform: "scale(1,1)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: cx('bar7'),
    r: "5",
    transform: "translate(0,0)",
    fill: fill2,
    stroke: "none",
    strokeWidth: "1"
  }))));
});

export { LoadingBasic as default };
